import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const DisableDevTools = () => {
  const location = useLocation();
  const [devToolsOpen, setDevToolsOpen] = useState(false);

  useEffect(() => {
    const checkUserEmail = () => {
      let userData = JSON.parse(localStorage.getItem("login_data"));
      let email = userData?.resp_user?.email;

      // Get the emails from the .env file
      const excludeEmails = process.env.REACT_APP_EXCLUDE_EMAILS
        ? process.env.REACT_APP_EXCLUDE_EMAILS.split(",")
        : [];

      if (excludeEmails.includes(email)) {
        // Remove restrictions for non-restricted users
        enableRightClick();
        enableKeyboardShortcuts();
        stopDevToolsDetection();
      } else {
        // Disable right-click and keyboard shortcuts for restricted users
        disableRightClick();
        disableKeyboardShortcuts();
        startDevToolsDetection();
      }
    };

    // Disable right-click
    const disableRightClick = () => {
      document.addEventListener("contextmenu", disableRightClickHandler);
    };

    // Enable right-click
    const enableRightClick = () => {
      document.removeEventListener("contextmenu", disableRightClickHandler);
    };

    const disableRightClickHandler = (event) => {
      event.preventDefault();
    };

    // Disable keyboard shortcuts
    const disableKeyboardShortcuts = () => {
      document.addEventListener("keydown", disableKeyboardHandler);
    };

    // Enable keyboard shortcuts
    const enableKeyboardShortcuts = () => {
      document.removeEventListener("keydown", disableKeyboardHandler);
    };

    const disableKeyboardHandler = (event) => {
      if (
        (event.ctrlKey && (event.key === "u" || event.key === "s")) || // Ctrl+U or Ctrl+S
        event.key === "F12" || // F12
        (event.ctrlKey &&
          event.shiftKey &&
          (event.key === "I" || event.key === "J")) // Ctrl+Shift+I or Ctrl+Shift+J
      ) {
        event.preventDefault();
      }
    };

    // DevTools detection variables
    let devToolsCheckInterval;
    const threshold = 160;

    // Multiple methods to detect DevTools
    const detectDevTools = () => {
      // Method 1: Check window size difference
      const widthThreshold = window.outerWidth - window.innerWidth > threshold;
      const heightThreshold =
        window.outerHeight - window.innerHeight > threshold;

      // Method 2: Check if Firebug is present
      const isFirebugActive =
        window.console &&
        (window.console.firebug ||
          (window.console.exception && window.console.table));

      // Method 3: Check devtools using toString method
      let devtoolsOpen = false;
      const element = new Image();
      Object.defineProperty(element, "id", {
        get: function () {
          devtoolsOpen = true;
          return "devtools";
        },
      });

      // Trigger the getter by logging
      requestAnimationFrame(() => {
        console.log("%c", element);
        console.clear();
      });

      if (
        widthThreshold ||
        heightThreshold ||
        isFirebugActive ||
        devtoolsOpen
      ) {
        // setDevToolsOpen(true);
      } else {
        setDevToolsOpen(false);
      }
    };

    // Start DevTools detection
    const startDevToolsDetection = () => {
      detectDevTools();
      devToolsCheckInterval = setInterval(detectDevTools, 500);

      // Also listen for resize events
      window.addEventListener("resize", detectDevTools);
    };

    // Stop DevTools detection
    const stopDevToolsDetection = () => {
      if (devToolsCheckInterval) {
        clearInterval(devToolsCheckInterval);
      }
      window.removeEventListener("resize", detectDevTools);
      setDevToolsOpen(false);
    };

    // Initialize by checking the current user
    checkUserEmail();

    // Listen to changes in localStorage (in case the user logs in again without refresh)
    window.addEventListener("storage", checkUserEmail);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("storage", checkUserEmail);
      enableRightClick();
      enableKeyboardShortcuts();
      stopDevToolsDetection();
    };
  }, [location]);

  // Render warning screen if DevTools is open
  if (devToolsOpen) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#000000",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999999,
          flexDirection: "column",
        }}
      >
        <div
          style={{
            color: "#ff0000",
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            textTransform: "uppercase",
            letterSpacing: "2px",
          }}
        >
          ⚠️ Inspect Menu Not Allowed ⚠️
        </div>
        <div
          style={{
            color: "#ff0000",
            fontSize: "18px",
            marginTop: "20px",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
          }}
        >
          Please close the developer tools to continue
        </div>
      </div>
    );
  }

  return null;
};

export default DisableDevTools;
